import getStructurePropertiesData from './getStructurePropertiesData';
import getStructurePropertiesDataWOHtml from './getStructurePropertiesDataWOHtml';

export default { getStructurePropertiesData, getStructurePropertiesDataWOHtml };
